import PropTypes from 'prop-types';
import useDebouncedValue from '../../../hooks/useDebouncedValue';
import { useEffect, useState } from 'react';

import { SearchInput } from '../../common/Search/SearchInput';

import styles from './ReportTable.module.scss';

export function ReportSearch({ onChange, value, placeholder }) {
  const [inputValue, setInputValue] = useState(value);
  const debouncedValue = useDebouncedValue(inputValue, 400);

  useEffect(() => {
    onChange(debouncedValue);
    // eslint-disable-next-line
  }, [debouncedValue]);

  return (
    <div className={styles.reportSearchWrapper}>
      <SearchInput value={inputValue} setValue={setInputValue} placeholder={placeholder} />
    </div>
  );
}

ReportSearch.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
